import { useCallback, useMemo } from 'react';
import { useTheme } from 'next-themes';

import { META_THEME_COLORS } from '@/config/site';

export function useMetaColor() {
  const { resolvedTheme } = useTheme();

  const metaColor = useMemo(
    () => (resolvedTheme !== 'dark' ? META_THEME_COLORS.light : META_THEME_COLORS.dark),
    [resolvedTheme],
  );

  const setMetaColor = useCallback((color: string) => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  }, []);

  return {
    metaColor,
    setMetaColor,
  };
}
